import React, { Component } from 'react';
import { Table, TableRow, TableCell, TableBody, pField, TableFooter, Button, Radio, Card, TableHead } from '@material-ui/core';
import withUser from '../HOC/HOCwithUser.jsx';
import HOCLoader from '../HOC/HOCLoader.jsx';
import ReactPlayer from 'react-player';
// import HOCLoader from '../HOC/HOCLoader';
import { getStatus, ROLE_PROVIDER, SERVER_URL } from '../../utils/config/constants.js';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Image from 'react-bootstrap/Image';
import { NotificationManager } from 'react-notifications';
import Dropzone from 'react-dropzone';
import { getCookies } from '../../utils/getToken.js';
import axios from 'axios';


export class ProviderTrainingCenter extends Component {
    constructor() {
        super();
        this.state = {
            datasource: [],
            videoData: [],
            radioValue: '',
            selectedData: [],
            isloading: true,
            test: false,
            video: false,
            hideVideoTable: false,
            hideTestTable: false,
            testAttempts: 0,
            totalAttempts: 0,
            watchedlist: 0,
            allList: 0

        }
    }

    componentDidMount() {
        const { userData } = this.props;
        this.QuizApi()
        this.VideoApi()
        this.getAttempts()
        this.getVideo()
    }
    getAttempts = () => {
        var authToken = getCookies();
        axios({
            method: 'get',
            url: `${SERVER_URL}/training-test/get-attempts`,
            headers: {
                'x-auth-Token': authToken
            }
        }).then((Response) => {
            // console.log("data traing test list length===============", Response);
            if (Response.data.status == 'OK') {
                this.setState({ testAttempts: Response.data.data.attempts, totalAttempts: Response.data.data.total_attempts })
            } else {
                this.setState({ testAttempts: 0, totalAttempts: 0 })
            }
        })
    }
    getVideo = () => {
        var authToken = getCookies();
        axios({
            method: 'post',
            url: `${SERVER_URL}/training-video/watched-list`,
            data: { provider_id: this.props.userData.id },
            headers: {
                'x-auth-Token': authToken
            }
        }).then((Response) => {
            if (Response.data.status == 'OK') {
                this.setState({ watchedlist: Response.data.data.length })
            } else {
                this.setState({ watchedlist: 0 })
            }
        })
    }

    videowatch = (video_id) => {
        console.log('wathvideo', video_id)
        var authToken = getCookies();
        axios({
            method: 'post',
            url: `${SERVER_URL}/provider/training-video/watched`,
            params: { video_id: video_id },
            headers: {
                'x-auth-Token': authToken
            }
        }).then((Response) => {
            // if (Response.data.status == 'OK') {
            //     this.setState({ video_id: Response.data.data.length})
            // } else {
            //     this.setState({ watchedlist: 0  })
            // }
        })
    }
    displayQuiz = () => {
        console.log('quiz button pressed')
        this.setState({ test: true, video: false, hideVideoTable: true })
    }
    displayVideo = () => {
        console.log('video button pressed')
        this.setState({ test: false, video: true, hideTestTable: true })

    }
    QuizApi = () => {
        var authToken = getCookies();
        // console.log('auth token:::::', authToken)
        axios({
            method: 'get',
            url: `${SERVER_URL}/admin/training-test/fetch`,
            headers: { 'x-auth-token': authToken }
        }).then(Response => {
            console.log("122response hai ye", Response)
            this.setState({ isloading: false, datasource: Response.data.data })
        })
    };
    VideoApi = () => {
        var authToken = getCookies();
        axios({
            method: 'get',
            url: `${SERVER_URL}/training-video/list`,
            headers: {
                'x-auth-Token': authToken
            }
        }).then(Response => {
            console.log("135 VIDEO RESPONSE", Response)
            if (Response.data.status == 'OK') {
                this.setState({ videoData: Response.data.data, allList: Response.data.data.length })
            } else {
                this.setState({ videoData: Response.data.data, allList: 0 })
            }
        });
    };
    handleSubmit = () => {
        if (this.state.selectedData == '') {
            NotificationManager.error('please select an option')
        }
        else {
            this.QuizSubmit();


        }
    }
    videoSubmit = () => {
        console.log("watch the video", this.state.videoData)
        if (this.state.videoData) {
            NotificationManager.error('please watch this video')
        }
        else {
            this.getVideo();
        }
    }

    QuizSubmit = () => {
        const { selectedData } = this.state;
        console.log('dataaaa', selectedData)
        if (selectedData == '') {
            NotificationManager.error("please select any option")
        } else {
            var authToken = getCookies();
            axios({
                method: 'post',
                url: `${SERVER_URL}/admin/training-test/attempt`,
                data: { "response": selectedData },
                headers: { 'x-auth-token': authToken }
            }).then(Response => {
                console.log("response hai yeee", Response)
                if (Response.data.status == 'OK') {
                    this.setState({ test: false, video: false, selectedData: [], radioValue: '' })
                    NotificationManager.success("Success!", Response.data.message)
                }
                else if (Response.data.status == "NOK") {
                    this.setState({ test: false, video: false, selectedData: [], radioValue: '' })
                    NotificationManager.error("Oops!", Response.data.message)
                }
                else {
                    NotificationManager.error("Oops!", Response.data.message)
                }
            })
        }
    };

    checkselcted(questionId, chosed) {
        const { radioValue, selectedData } = this.state;
        var found = false;

        for (var x in selectedData) {
            console.log(x)
            if (selectedData[x].id == questionId) {
                selectedData[x].answer = chosed;
                found = true;
                break;
            }
        }

        if (!found) {
            selectedData.push({ 'id': questionId, 'answer': chosed });
        }
        console.log('radiovalue in function::::', selectedData)
        this.setState({
            selectedData: selectedData
        })
    }

    isSelected(questionId) {
        const { selectedData } = this.state;
        var selected = 0;

        for (var x in selectedData) {
            if (selectedData[x].id == questionId) {
                selected = selectedData[x].answer;
                break;
            }
        }
        return selected;
    }

    renderquiz = () => {

        const { datasource } = this.state;
        console.log('quiz dataaaaa:::::', datasource)
        return (
            <HOCLoader loading={this.state.isloading}>
                <div>
                    {datasource.length == 0 &&
                        <Paper style={{ margin: 10, padding: 20 }}>
                            <h4>
                                No Quiz Available
                            </h4>
                        </Paper>}
                    {datasource.length > 0 && <div style={{ marginLeft: '10px' }} className="ds-boar-title">
                        <h2>Attempt Test</h2>
                    </div>}
                    {datasource.length > 0 && datasource.map(item => {
                        var selectedOption = this.isSelected(item.id);
                        console.log('selected option', selectedOption)
                        return (
                            <div>
                                <Card style={{ margin: 10 }}>
                                    <p style={{ padding: 10, color: 'black', fontSize: 18 }}>Q. {item.question}</p>
                                    <div>
                                        <Card className="row radbg" onClick={() => this.checkselcted(item.id, 1)} >
                                            <Radio
                                                style={{ marginLeft: 10 }}
                                                onChange={() => this.checkselcted(item.id, 1)}
                                                checked={1 == selectedOption}
                                            />
                                            <p onClick={() => this.checkselcted(item.id, 1)} style={{ paddingTop: '12px' }}>{item.option_1}</p>
                                        </Card>

                                        <Card className="row radbg" onClick={() => this.checkselcted(item.id, 2)}>
                                            <Radio
                                                style={{ marginLeft: 10 }}
                                                onChange={() => this.checkselcted(item.id, 2)}
                                                checked={2 == selectedOption}
                                            />
                                            <p onClick={() => this.checkselcted(item.id, 2)} style={{ paddingTop: '12px' }}  >{item.option_2}</p>
                                        </Card>

                                        <Card className="row radbg" onClick={() => this.checkselcted(item.id, 3)}>
                                            <Radio
                                                style={{ marginLeft: 10 }}
                                                onChange={() => this.checkselcted(item.id, 3)}
                                                checked={3 == selectedOption}
                                            />
                                            <p onClick={() => this.checkselcted(item.id, 3)} style={{ paddingTop: '12px' }}  >{item.option_3}</p>
                                        </Card>

                                        <Card className="row radbg" onClick={() => this.checkselcted(item.id, 4)}>
                                            <Radio
                                                style={{ marginLeft: 10 }}
                                                onChange={() => this.checkselcted(item.id, 4)}
                                                checked={4 == selectedOption}
                                            />
                                            <p onClick={() => this.checkselcted(item.id, 4)} style={{ paddingTop: '12px' }} >{item.option_4}</p>
                                        </Card>
                                    </div>
                                </Card>
                            </div>


                        )
                    })}
                    {datasource.length > 0 && <Button
                        className="center"
                        loading={true}
                        variant="outlined"
                        color="primary"
                        style={{ marginLeft: '25%', width: '50%' }}
                        onClick={() => this.handleSubmit()}>
                        Submit</Button>}

                    {!datasource && <div style={{ marginLeft: '10px' }} className="ds-boar-title">
                        <h4> No Quiz Available
                        </h4>
                    </div>}
                </div>
            </HOCLoader>
        )
    }

    renderVideo = () => {
        const { videoData } = this.state;
        console.log('video DATAAAAAA', videoData)
        return (
            <HOCLoader loading={this.state.isloading}>
                <div style={{ margin: 10 }}>
                    {videoData.length > 0 && videoData.map(item => {
                        return (
                            <div style={{ justifyContent: 'center' }} className="player-wrapper">
                                <video width="100%" controls onPlay={() => this.videowatch(item.id)} >
                                    <source src={item.video} />
                                </video>
                                {/* <ReactPlayer url={item.video}       width="100"     controls={true}  onClick={() => this.videowatch()} /> */}
                                <p>{item.title}</p>
                            </div>
                        )
                    })}
                    {/* {videoData.length > 0 && <Button
                        className="center"
                        loading={true}
                        variant="outlined"
                        color="primary"
                        style={{ marginLeft: '25%', width: '50%' }}
                        onClick={() => this.videoSubmit()}>
                        Submit</Button>} */}

                    {videoData.length == 0 && <Paper style={{ margin: 10, padding: 20 }}>
                        <h4> No Video Available
                        </h4>
                    </Paper>
                    }
                </div>
            </HOCLoader>
        )
    }

    render() {
        // console.log('datasourceee:::::::::::', this.state.datasource)
        // const{test,video, videoData} = this.state;
        // console.log('video data on the state',videoData)
        return (
            // <FullScreenLoading style={{ flex: 1, }} spinner={this.state.loading}>
            <HOCLoader loading={this.state.isloading}>
                <div className="row md-12 p-2" style={{ justifyContent: "space-between" }}>
                    <Paper id='training_data' elevation={2} style={{ borderWidth: 1, borderStyle: "solid", borderColor: "#dddddd", width: "100%" }} className="md-6">
                        <Table className="table">
                            <TableHead>
                                <div className="ml-2" style={{ height: 50, width: "100%", display: "flex", alignItems: "center" }}>
                                    <h4><b>Test Analysis</b></h4>
                                </div>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell className="text-left pl-4">
                                        Attempts
                                        :
                                    </TableCell>
                                    <TableCell className="text-left">
                                        {this.state.testAttempts}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell className="text-left pl-4">
                                        Total Attempts Allowed
                                        :
                                    </TableCell>
                                    <TableCell className="text-left">
                                        {this.state.totalAttempts}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                            <TableFooter>
                                <TableCell colSpan={2} style={{ textAlign: "center" }}>
                                    <Button
                                        className="buttonload"
                                        style={{ width: '50%', }}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.displayQuiz()}>Start Test</Button>
                                </TableCell>

                            </TableFooter>
                        </Table>
                        <div style={{ marginTop: '10px' }}>
                            {this.state.test == true && this.renderquiz()}
                        </div>
                    </Paper>
                    <Paper id='training_data' elevation={2} style={{ borderWidth: 1, borderStyle: "solid", borderColor: "#dddddd", width: "100%" }} className="md-6">
                        <Table className="table">
                            <TableHead>
                                <div className="ml-2" style={{ height: 50, width: "100%", display: "flex", alignItems: "center" }}>
                                    <h4><b>Tutorial Video Analysis</b></h4>
                                </div>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell className="text-left pl-4">
                                        Watched Video
                                        :
                                    </TableCell>
                                    <TableCell className="text-left">
                                        {this.state.watchedlist}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell className="text-left pl-4">
                                        Total Videos
                                        :
                                    </TableCell>
                                    <TableCell className="text-left">
                                        {this.state.allList}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                            <TableFooter>
                                <TableCell colSpan={2} style={{ textAlign: "center" }}>
                                    <Button
                                        style={{ width: '50%' }}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.displayVideo()}>Start Video
                                    </Button>
                                </TableCell>


                            </TableFooter>
                        </Table>
                        <div style={{ marginTop: '10px' }}>
                            {this.state.video == true && this.renderVideo()}
                        </div>
                    </Paper>
                </div>
            </HOCLoader>
        );
    }
}

export default withUser(ProviderTrainingCenter);



// WEBPACK FOOTER //
// ./src/components/Providers/ProviderTrainingCenter.jsx